import { VersionInfo } from "./Contexts/VersionInfo"

export const version = new VersionInfo(
  true,
  "latest", // Version
  11287,   // build
  "a61ed4adebb99b4ead93da15c85be5b4f4441539",    // hash
  "2026",    // buildYear
  "2026-09-03" // buildDate
)
